/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramCategoryControllerFindAllQueryResponse } from '../types/TelegramCategoryControllerFindAll.ts';

function getTelegramCategoryFindAllUrl() {
  const res = { method: 'GET', url: `/api/telegram/category` as const };
  return res;
}

/**
 * {@link /api/telegram/category}
 */
export async function telegramCategoryFindAll(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramCategoryControllerFindAllQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramCategoryFindAllUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
